import * as React from 'react';
import cn from 'clsx';
import { TInputType } from '@cian/ui-kit/input/types';
import { Button } from '@cian/ui-kit/button';
import { useDeviceType } from '@cian/ui-kit/responsive';

import { ChangePhone } from '../ChangePhone';
import { CountDown } from '../CountDown';
import { FormInputsLayout } from '../../../FormInputsLayout';

import * as styles from './styles.css';

export interface IVerifyFieldProps {
  value: string;
  error?: string;
  isValid: boolean;
  seconds: number;
  phone: string;
  fetching?: boolean;
  buttonText: string;
  checked: boolean;

  onChangePhone(): void;

  onChange(value: string): void;

  onSubmit(code: string, phone: string, checked: boolean): void;

  restart(phone: string): void;
}

export const VerifyField: React.FC<React.PropsWithChildren<IVerifyFieldProps>> = ({
  onSubmit,
  fetching,
  isValid,
  error,
  value,
  seconds,
  onChange,
  restart,
  onChangePhone,
  phone,
  buttonText,
  checked,
}) => {
  const deviceType = useDeviceType();
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value),
    [onChange],
  );
  const handleSubmit = React.useCallback(() => onSubmit(value, phone, checked), [onSubmit, value, phone, checked]);
  const handleRestart = React.useCallback(() => restart(phone), [restart, phone]);

  const containerClassNames = React.useMemo(
    () =>
      cn(styles['container'], {
        [styles['mobile']]: deviceType === 'phone',
      }),
    [deviceType],
  );

  return (
    <div className={containerClassNames}>
      <ChangePhone phone={phone} onChangeClick={onChangePhone} />
      <div className={styles['field']}>
        <FormInputsLayout
          InputProps={{
            invalid: !!error,
            type: 'tel' as TInputType,
            placeholder: 'Код из смс',
            onChange: handleChange,
            disabled: fetching,
            errorMessage: error,
            name: 'phone_verify',
            value,
          }}
          fullwidth
        />
      </div>
      <div className={styles['submit']}>
        <Button size={'M'} disabled={!isValid} onClick={handleSubmit} loading={fetching}>
          {buttonText}
        </Button>
      </div>
      <div className={styles['count-down']}>
        <CountDown seconds={seconds} onClick={handleRestart} />
      </div>
    </div>
  );
};

VerifyField.displayName = 'VerifyField';
